import { EnvironmentService } from "./Services/Environment/environment.service";

export class ConfigurationSettings {
 
    private static envConfig=new EnvironmentService();

    public static appLink = ConfigurationSettings.envConfig.currentEnvironment.host[0];
    public static API_URL = ConfigurationSettings.envConfig.currentEnvironment.apiUrl;

}
